import slick from 'slick-carousel';
import imgLiquid from 'plugs/imgLiquid-min.js';
import 'plugs/jquery.mmenu.all.js';
import 'plugs/jquery.easing.1.3.js';
import 'plugs/svg.js';


var $window = $(window);
var winW,winH,footerH,bodyH,scrollTop;
$(function() {    
    $('body').addClass('fade-in');
    $("#topBtn").click(function() {
        $("html,body").animate({ scrollTop: 0 }, 1000, 'easeOutExpo');
        return false;
    });
    //menu active mode(select this)
    var menu_active = $('.menu-active').data("menu");
    $('.navBox > li > a').eq(menu_active[0] - 1).addClass('active');
    $('nav#menu').mmenu({
        "openPanel:start": ( panel ) => {
            console.log( "Started opening pane: " + panel.id );
         },
    });
    var API = $("nav#menu").data( "mmenu" );    
    $window.on('resize',function(){
        winW = $window.width();
        winH =  $window.height();
        footerH = $('footer').outerHeight(true);
        bodyH = winH - footerH;  
        //bodyH
        $('main').css('min-height',bodyH);
        if(winW >=991){
            API.close();
       }
       //header padding for pc
       var header_left = $('header .navBox > li:nth-child(1)').offset().left;
        $('.subBox > div').css('padding-left',header_left);
        resizeBgcover(winW);//background-image
        //top menu
        if($('#top-menu-ul').length > 0){ 
            $('.top-menu-ul li').eq(menu_active[1] - 1).addClass('active');
            var menu_ul = $('#top-menu-ul ul').width();
            var menu_box = $('#top-menu-ul .item_menu_Box').width();
            
            $('#top-menu-ul').removeClass('open_flexslider');
            $('#top-menu-ul .slides').removeAttr('style');
            $('#top-menu-ul .item_menu_Box').removeAttr('style');
            if(menu_ul > menu_box ){
                $('#top-menu-ul').addClass('open_flexslider'); 
            }
            slider_ul_list(); 
        }
    }).resize();   

    $window.on('scroll', function() {
        scrollTop = $(this).scrollTop();
        gotopfun(scrollTop);
    }).scroll();
});

				